import {
  POSDeviceResponse,
  CreatePOSDeviceRequest,
  EditPOSDeviceRequest,
} from '../../model/POS-device.model';
import axiosInstance from '../../utils/axiosInstance';

// Interface cho phản hồi từ API tối ưu POS
export interface OptimalPOSResponse {
  posId: number;
  deviceCode: string;
  location: string;
  status: string;
  bank: {
    id: number;
    name: string;
    bankCode: string;
  };
  feeRate: number;
  transactionCount: number;
  referenceDate?: string; // Ngày bắt đầu tính số lần quẹt thẻ (30 ngày trước)
}

class POSDeviceService {
  async getPOSDeviceList(): Promise<POSDeviceResponse[]> {
    try {
      const { data } = await axiosInstance.get('/pos-devices');
      return data;
    } catch (error) {
      console.error('Lỗi khi tải danh sách thiết bị POS:', error);
      throw new Error(
        'Lỗi khi tải danh sách thiết bị POS: ' + this.getErrorMessage(error)
      );
    }
  }

  async createPOSDevice(
    posDevice: CreatePOSDeviceRequest
  ): Promise<POSDeviceResponse> {
    try {
      const { data } = await axiosInstance.post(
        '/pos-devices/create',
        posDevice
      );
      return data;
    } catch (error) {
      console.error('Lỗi khi tạo thiết bị POS:', error);
      throw new Error(
        'Lỗi khi tạo thiết bị POS: ' + this.getErrorMessage(error)
      );
    }
  }

  async editPOSDevice(
    posId: number,
    posDevice: EditPOSDeviceRequest
  ): Promise<POSDeviceResponse> {
    try {
      const { data } = await axiosInstance.put(
        `/pos-devices/edit/${posId}`,
        posDevice
      );
      return data;
    } catch (error) {
      console.error('Lỗi khi chỉnh sửa thiết bị POS:', error);
      throw new Error(
        'Lỗi khi chỉnh sửa thiết bị POS: ' + this.getErrorMessage(error)
      );
    }
  }

  async deletePOSDevice(posId: number): Promise<void> {
    try {
      await axiosInstance.delete(`/pos-devices/delete/${posId}`);
    } catch (error) {
      console.error('Lỗi khi xóa thiết bị POS:', error);
      throw new Error(
        'Lỗi khi xóa thiết bị POS: ' + this.getErrorMessage(error)
      );
    }
  }

  /**
   * Lấy danh sách POS tối ưu cho thẻ tín dụng cụ thể
   * @param creditCardId ID của thẻ tín dụng
   * @param transactionDate Ngày giao dịch (tùy chọn)
   * @returns Danh sách POS tối ưu với thông tin phí và số lần sử dụng
   */
  async getOptimalPOSDevicesForCard(
    creditCardId: number,
    transactionDate?: string
  ): Promise<OptimalPOSResponse[]> {
    try {
      const { data } = await axiosInstance.get('/pos-devices/optimal', {
        params: {
          creditCardId,
          transactionDate,
        },
      });
      return data;
    } catch (error) {
      console.error('Lỗi khi tải danh sách POS tối ưu:', error);
      throw new Error(
        'Lỗi khi tải danh sách POS tối ưu: ' + this.getErrorMessage(error)
      );
    }
  }

  // Helper method to extract error messages
  private getErrorMessage(error: any): string {
    return (
      error.response?.data?.message || error.message || 'Lỗi không xác định'
    );
  }
}

export default new POSDeviceService();
